import React from "react";
import { motion } from "framer-motion";

export function CustomCursor({ pos }) {
  const isTouch =
    typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches;
  if (isTouch) return null;

  return (
    <>
      <motion.div
        aria-hidden
        className="pointer-events-none fixed z-[999]"
        style={{ left: 0, top: 0 }}
        animate={{ x: pos.x - 5, y: pos.y - 5 }}
        transition={{ type: "spring", stiffness: 600, damping: 35 }}
      >
        <div
          className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
            pos.hover ? "bg-acid scale-[3]" : "bg-paper/70"
          }`}
        />
      </motion.div>
      <motion.div
        aria-hidden
        className="pointer-events-none fixed z-[998] rounded-full border transition-opacity duration-300"
        style={{ left: 0, top: 0 }}
        animate={{ x: pos.x - 22, y: pos.y - 22 }}
        transition={{ type: "spring", stiffness: 250, damping: 26 }}
      >
        <div
          className={`rounded-full border ${
            pos.hover ? "w-11 h-11 border-acid/60" : "w-11 h-11 border-paper/15"
          }`}
        />
      </motion.div>
    </>
  );
}
